export const UPDATE_JOINTHOLDER_MODAL = 'UPDATE_JOINTHOLDER_MODAL'
export const UPDATE_JOINTHOLDER_FLOW_SCREEN = 'UPDATE_JOINTHOLDER_FLOW_SCREEN'